import { Form, Select, message } from "antd";
import { DateObject } from "react-multi-date-picker";
import moment from 'moment-hijri';
const win: any = window;

export const Error = (msg: string) => message.error(msg, 3);
export const Success = (msg: string) => message.success(msg, 3);

export const isEmpty = (obj: any) => {
  return Object.keys(obj).length === 0;
};

export const CheckResponse = (res: any, lang: string) => {
  let errorMsg = "";
  const objCheck = typeof (res);

  if (objCheck === "object") {
    if (res.code === "MAPI-8022" || res.code === "MAPI-400") {
      errorMsg = lang === "en" ? res.englishDetail : res.arabicDetail;
    } else {
      errorMsg = lang === "en" ? res.englishDetail : res.arabicDetail;
      setTimeout(() => {
        window.location = win["home_page_url"];
      }, 2000);
    }
  }

  errorMsg = errorMsg === undefined || null ? res.statusText : errorMsg;

  return { errorMsg };
};

export const prefixSelector = (name = 'prefix') => {
  return (
    <Form.Item name={name} noStyle>
      <Select
        style={{
          width: 80,
          direction: 'ltr'
        }}
      >
        <Select.Option value="966">+966</Select.Option>
      </Select>
    </Form.Item>
  );
}

export const convertCalendarDate = (date: any) => {
  if (date instanceof DateObject) {
    const formattedDate = date.format('YYYY-MM-DD');
    return date.calendar.name === 'arabic' ? moment(formattedDate, 'iYYYY-iMM-iDD').format('YYYY-MM-DD') : formattedDate
  }
  return date;
}